import translations from './i18n.json';

import { translateInComponent } from 'infras/i18n';
import { useCallback, useMemo } from 'react';
import ToggleButtonGroup from 'presentations/views/components/atoms/ToggleButtonGroup';
import { useRouter } from 'next/router';
import {
  dashboardCalendarsPath,
  dashboardEventTypeCalendarPath,
  dashboardEventTypePollPath,
} from 'presentations/routes/path';

interface Props {}

enum ViewType {
  Event = '1',
  OneOff = '2',
  Poll = '3',
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  const router = useRouter();

  const viewType = useMemo(() => {
    if (!router.asPath) return;
    if (router.asPath.startsWith(dashboardCalendarsPath())) {
      return ViewType.Event;
    } else if (router.asPath.startsWith(dashboardEventTypePollPath(''))) {
      return ViewType.Poll;
    } else if (router.asPath.startsWith(dashboardEventTypeCalendarPath(''))) {
      return ViewType.OneOff;
    }
    return ViewType.Event;
  }, [router.asPath]);

  const viewTypeItems = useMemo(() => {
    return [
      { label: t('Calendar'), value: ViewType.Event },
      { label: t('One-Off'), value: ViewType.OneOff },
      { label: t('Poll'), value: ViewType.Poll },
    ];
  }, []);

  const onChangeViewType = useCallback(
    (props: { value: string }) => {
      switch (props.value as ViewType) {
        case ViewType.Event:
          router.push(dashboardCalendarsPath());
          break;
        case ViewType.OneOff:
          router.push(dashboardEventTypeCalendarPath(router.asPath));
          break;
        case ViewType.Poll:
          router.push(dashboardEventTypePollPath(router.asPath));
          break;
        default:
          break;
      }
    },
    [router.asPath],
  );

  return (
    <ToggleButtonGroup
      value={viewType as string}
      onChange={onChangeViewType}
      items={viewTypeItems}
    />
  );
}
